module.exports = __webpack_public_path__ + "static/media/blog5.f3bcbb87.png";